import { render, staticRenderFns } from "./AttendeeRegEdit.vue?vue&type=template&id=0afed1fb&v-if=isJsonLoaded&"
import script from "./AttendeeRegEdit.vue?vue&type=script&lang=js&"
export * from "./AttendeeRegEdit.vue?vue&type=script&lang=js&"
import style0 from "./AttendeeRegEdit.vue?vue&type=style&index=0&id=0afed1fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports